import { Table, Center } from "@mantine/core";
import React, { Component } from "react";

// Helper function to format numbers with commas for whole numbers
function formatNumber(value) {
  const stringValue = value.toString();
  const parts = stringValue.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

export class ExchangeTable extends Component {
  // componentDidMount() {
  //   this.props.subscribeToNewOrderBook();
  // }
  render() {
    return (
      <Table verticalSpacing="xs" highlightOnHover style={{ tableLayout: "fixed" }}>
        <thead>
          <tr>
            <th colSpan={Object.keys(this.props.currencyArray[0]).length}>
              <Center>{this.props.title}</Center>
            </th>
          </tr>
          <tr>
            <th>
              <Center>Amount ({this.props.currencyArray[0]})</Center>
            </th>
            <th>
              <Center>Price ({this.props.currencyArray[1]})</Center>
            </th>
            <th>
              <Center>Total ({this.props.currencyArray[1]})</Center>
            </th>
          </tr>
        </thead>
        <tbody>
          {this.props.arr &&
            this.props.arr.map((item, index) => (
              <tr key={index}>
                <td>
                  <Center>{formatNumber(Number(item[1]).toFixed(5).substring(0, 7))}</Center>
                </td>
                <td style={{ color: this.props.color }}>
                  <Center>{formatNumber(item[0])}</Center>
                </td>
                <td>
                  <Center>
                    {formatNumber((Number(item[1]) * Number(item[0]))
                      .toFixed(5)
                      .substring(0, 7))}
                  </Center>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    );
  }
}
